import Cookies from "js-cookie";
import { useEffect } from "react";
import type { ReactElement } from "react";
import { useNavigate, useSearchParams } from "react-router-dom"; 
import { COGNITO_ID_TOKEN_KEY } from "src/config";
import { Paths } from "src/navigation";
import { GET_TOKEN_HEADER, useGetIdToken } from "src/networking";
import { useDraftIDStore } from "src/storage/formik/formik-draft.store";
import type { PrivateRouteProps } from "src/types";
import { typedMemo } from "src/types";

export const PrivateRoute = typedMemo(
  ({ element }: PrivateRouteProps): ReactElement => {
    const { crossGate: getIdToken } = useGetIdToken();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams(); 

    const draftId = useDraftIDStore((state) => state.draftID);
    const setDraftID = useDraftIDStore((state) => state.setDraftID);
    const urlCode = searchParams.get("code");
    
    const requestToken = async () => {
      await getIdToken(
        {
          headers: GET_TOKEN_HEADER,
        },
        {
          onSuccess: (response) => {
            const idToken = response?.idToken;
            if (idToken) {
              Cookies.set(COGNITO_ID_TOKEN_KEY, `Bearer ${idToken}`);
            }
          },
        },
      );
    };

    useEffect(() => {
      const init = async () => {
        if (!Cookies.get(COGNITO_ID_TOKEN_KEY)) {
          try {
            await requestToken();
          } catch (error) {
            console.error("Error during retrieving the token:", error);
          }
        }
      };

      let currentId = draftId;

      if(urlCode){
        currentId = "pending";
      }

      if (currentId == null) {
        const urlIdBozza = searchParams.get("idBozza");
        if (urlIdBozza) {
          setDraftID(urlIdBozza);
          currentId = urlIdBozza;
        }
      }

      if (currentId == null) {
        navigate(Paths.Landing, { replace: true });
        return;
      }

      init();
    }, []);

    return element;
  },
);
